export default {
  mounted() {
    setTimeout(() => {
      // this.el.querySelector('input').focus()
      const targetElement = this.el.querySelector(`#${this.el.dataset.target}`)

      // If an element is found, focus it
      const maybeSelect = this.el.querySelector(`#${this.el.dataset.target}_select-ts-control`)
      if (maybeSelect) {
        maybeSelect.focus()
      } else {
        if (targetElement) {
          targetElement.focus()
        } else {
          const firstInput = this.el.querySelector('input')
          if (firstInput) {
            firstInput.focus()
          } else {
            this.el.focus()
          }
        }
      }
    }, 100)
  },
}
